function trackDisplayNewsletter(popinType) {
    var result = {
        popinType: popinType
    };
    if (typeof tC !== 'undefined' && typeof tC.event !== 'undefined' && typeof tC.event.newsletterDisplay !== 'undefined') {
        tC.event.newsletterDisplay(this, result);
    }
    if (isNotWwwDomain) {
        demoEvent('tC.event.newsletterDisplay', result);
    }
}

function trackNewsletterSubscription(popinPosition) {
    var result = {
        position: popinPosition
    };
    if (typeof tC !== 'undefined' && typeof tC.event !== 'undefined' && typeof tC.event.newsletterSubscription !== 'undefined') {
        tC.event.newsletterSubscription(this, result);
    }
    if (isNotWwwDomain) {
        demoEvent('tC.event.newsletterSubscription', result);
    }
}